module.exports = __webpack_public_path__ + "static/media/bg-survey2.5c81aa02.svg";